import { render, staticRenderFns } from "./ListNews.vue?vue&type=template&id=497e0d85&"
import script from "./ListNews.vue?vue&type=script&lang=js&"
export * from "./ListNews.vue?vue&type=script&lang=js&"
import style0 from "./ListNews.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Tag: require('/home/runner/work/myody_front/myody_front/components/tag/Tag.vue').default,TagList: require('/home/runner/work/myody_front/myody_front/components/tag/TagList.vue').default,Link: require('/home/runner/work/myody_front/myody_front/components/link/Link.vue').default,Card: require('/home/runner/work/myody_front/myody_front/components/card/Card.vue').default})
